import { Loader } from "@/components/Loader/Loader";
import { chargingPoolQueryOptions } from "@/modules/charging-pool/queries/useChargingPool.query";
import { EvsePage } from "@/pages/EvsePage/EvsePage";
import { NotFoundPage } from "@/pages/NotFoundPage/NotFoundPage";
import { createFileRoute, notFound } from "@tanstack/react-router";

export const Route = createFileRoute("/qrs/$evseId/")({
	loader: async ({ params, context }) => {
		const pool = await context.queryClient.ensureQueryData(chargingPoolQueryOptions(params.evseId));

		if (!pool?.chargingPool?.chargingPoolId) {
			throw notFound();
		}
	},
	pendingComponent: Loader,
	notFoundComponent: NotFoundPage,
	errorComponent: NotFoundPage,
	component: EvsePage,
});
